import {
  Box,
  Button,
  Divider,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FC, useMemo } from "react";
import { FormCliente } from "./FormCliente";
import { BottomBar } from "src/framework/components/commons/BottomBar";
import { PageTitle } from "src/components/projetos/PageTitle";
import { Projeto } from "src/components/projetos/types";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import theme from "src/theme/light";
import { useObservable } from "src/framework/store/storeUtil";
import { isLoading$ } from "src/framework/store/ApiEvents";
import { FormDistribuidorRevenda } from "./FormDistribuidorRevenda";

const tipoProjetoString: { [index: string]: string } = {
  "personalizado": "personalizado offgrid",
  "personalizado_offgrid": "personalizado offgrid"
}

interface FormClientProperties {
    projetoState: any;
    onChangeValue: (projetoState: any) => void
    errorState: string[];
    onChangeError: (errorState: any) => void
    distribuidorRevendaUsuario: any
    readOnly?: boolean
    onClickNext: () => void
    onSaveAndClose: (projetoState: any) => void
}

const useStyles = makeStyles({
  customButton: {
    backgroundColor: '#CC8F00'
  },
})

const FormDados: FC<FormClientProperties> = ({ onSaveAndClose, onClickNext, readOnly, projetoState, onChangeValue, errorState, onChangeError, distribuidorRevendaUsuario }) => {
  const classes = useStyles()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const FooterBottom = isMobile ? Box : BottomBar;
  const isLoading = useObservable(isLoading$);
  
  const nextButtonIsDisabled = useMemo(() => {
    const requiredFields: (keyof Projeto)[] = [
      "cliente_proposta",
      "cidade",
      "estado",
      "tipo"
    ]

    if (projetoState.tipo !== "vertical") {
      requiredFields.push("latitude", "longitude")
    }

    for (const requiredField of requiredFields) {
      if (!projetoState?.[requiredField]) {
        return true;
      }
    }

    if (isLoading) return true;

    if (projetoState?.email_proposta && (!ValidateUtil.isValidEmail(projetoState?.email_proposta) || errorState?.includes('email_proposta'))) return true;

    if (projetoState?.cep && projetoState?.cep?.length < 9) return true;

  }, [projetoState, errorState, isLoading])

  const pageTitle = useMemo(()=>{
    let tipoString = projetoState?.tipo ? (tipoProjetoString[projetoState.tipo] || projetoState.tipo) : '';
    let segmentoString = projetoState?.segmento.includes("off") ? "Off Grid" : "On Grid";

    segmentoString = "Off Grid";
    tipoString = tipoString.replace(" offgrid", "");

    if (!projetoState?.clonar_projeto && projetoState?.isEdit) return `Edição de projeto ${tipoString} ${segmentoString}`
    return `Novo projeto ${tipoString} ${segmentoString}`
  },[projetoState?.clonar_projeto, projetoState?.tipo, projetoState?.isEdit, projetoState?.segmento])

  return (
    <>
      <Box p={2}>
        <PageTitle title={pageTitle} subtitle='Preencha os dados do cliente' />
      </Box>

      <Divider className="X12" />

      <Box p={2}>
        <Box className="X12" py={2}>
          <Typography variant="h6" align="left"><strong>Dados do cliente:</strong></Typography>
        </Box>

        <FormDistribuidorRevenda
          projetoState={projetoState}
        />

        <FormCliente
          errorState={errorState}
          onChangeError={onChangeError}
        />
      </Box>

      <FooterBottom className="fotter-bottom">
        {!readOnly && (projetoState?.tipo !== 'kit') && (projetoState?.tipo !== 'vertical') && (!projetoState.isEdit) &&
          <Button
            disableElevation={true}
            color={"secondary"}
            variant={"contained"}
            onClick={() => onSaveAndClose(projetoState)}
            disabled={nextButtonIsDisabled}
            className={classes.customButton}
            fullWidth={isMobile}
            >
            Salvar e Fechar
          </Button>
        }
        {!readOnly && 
          <Tooltip title={nextButtonIsDisabled ? 'Para prosseguir, preencha os campos marcados como *obrigatório.' : ''}>
            <Button
              disableElevation={true}
              disabled={nextButtonIsDisabled}
              color={"primary"}
              variant={"contained"}
              onClick={onClickNext}
              fullWidth={isMobile}
              style={isMobile ? { marginTop: 10 } : {}}
              >
              Continuar meu projeto
            </Button>
          </Tooltip>
        }

        {!readOnly && nextButtonIsDisabled && isMobile && <Box className="label-inputs" color="">
          <small>Para prosseguir, preencha os campos marcados como <span className="label-emphasis">*</span>obrigatório.</small>
        </Box>}
      </FooterBottom>
    </>
  )
}

export { FormDados }
